<form [formGroup]="timeForm" (ngSubmit)="validateInput()">
  <div class="action-wrapper">
    <div class="input-group flex_sb">
      <div>
        <input
          type="number"
          placeholder="HH"
          formControlName="hour"
          class="time-input"
          [class.error]="hasError('hour')"
        />
        <div class="fs-12 fw-400 clr-666 ta_center m-t-4">hour</div>
      </div>
      <div class="separator fs-24 m-l-12 m-r-12 m-b-24">:</div>
      <div>
        <input
          type="number"
          placeholder="MM"
          formControlName="minute"
          class="time-input"
          [class.error]="hasError('minute')"
        />
        <div class="fs-12 fw-400 clr-666 ta_center m-t-4">minute</div>
      </div>
    </div>

    <div class="button-group flex_sb m-t-16">
      <button
        type="button"
        class="period-button"
        [class.active]="period === 'AM'"
        (click)="setPeriod('AM')"
      >
        AM
      </button>
      <button
        type="button"
        class="period-button m-l-8"
        [class.active]="period === 'PM'"
        (click)="setPeriod('PM')"
      >
        PM
      </button>
    </div>
  </div>

  <div *ngIf="timeForm.invalid && timeForm.touched" class="error-message">
    Please enter valid values.
  </div>
</form>
